<template>
	<div class="row dynvibeSearch">
		<div id="dynvibeSearchFiltersBase" class="col-lg-12">
			<select id="dynvibeListPanels" class="listPanels dynvibeListPanels" v-model="selectedPanel">
				<option value="">Choose Panels</option>
				<option v-for="(item, index) in this.panels" :key="index">
					{{ item._source.label }}
				</option>
			</select>
			<select id="dynvibeListSegments" class="listSegments dynvibeListSegments" v-model="selectedSegment">
				<option value="">Choose segments</option>
				<option v-for="(item, index) in this.segmentsAll" :key="index">
					{{ item._source.label }}
				</option>
			</select>

			<select id="fli" class="listSegments" name="country" data-type="country" v-model="selectedCountry">
				<option value="">Choose country</option>
				<option v-for="country in countries" v-bind:key="country.id" :value="country.id">
					{{ country.name }}
				</option>
			</select>
			<select id="dynvibeListCategory" class="dynvibeListCategory" v-model="selectedCategory">
				<option value="">Choose Category</option>
				<option v-for="(item, index) in this.categories" :key="index">
					{{ item }}
				</option>
			</select>
			<select id="dynvibeListSubcategory" class="dynvibeListSubcategory" v-model="selectedSubCategory">
				<option value="">Choose SubCategory</option>
				<option v-for="(item, index) in this.subcategories" :key="index">
					{{ item }}
				</option>
			</select>
			<select id="dynvibeListMastertags" class="dynvibeListMastertags" v-model="selectedMastertag" v-if="displayincoming == true">
				<option value="">Choose Mastertag</option>
				<option v-for="(item, index) in this.mastertags" :key="index">
					{{ item }}
				</option>
			</select>
			<span class="dynvibeButton" v-if="showCreateTrends" @click="openTrendModel">Create / Edit Trend</span>
		</div>
		<editcreatemodal ref="editcreatetrends" @updatetrends="$emit('updatetrends')"></editcreatemodal>
	</div>
</template>

<script>
//import confirm from "@/components/globalVue/Confirm.vue";
import editcreatemodal from "@/components/trend/editCreateModal.vue";

export default {
	props: {
		displayincoming: {
			type: Boolean,
			default: false,
		},
		showCreateTrends: {
			type: Boolean,
			default: false,
		},
		selectedDate: {
			type: Object,
			default: function () {
				return {};
			},
		},
	},
	name: "newtrendfilter",
	components: {
		//confirm: confirm,
		editcreatemodal: editcreatemodal,
	},
	emits: ["updatetrends", "trendfilters"],
	data() {
		return {
			data: [],
			segments: [],
			segmentsAll: [],
			panels: [],
			categories: [],
			subcategories: [],
			mastertags: [],
			selectedSegment: "",
			selectedPanel: "",
			selectedCountry: "",
			selectedCategory: "",
			selectedSubCategory: "",
			selectedMastertag: "",
			countries: [
				{ id: "ar", name: "Argentina" },
				{ id: "au", name: "Australia" },
				{ id: "at", name: "Austria" },
				{ id: "be", name: "Belgium" },
				{ id: "br", name: "Brasil" },
				{ id: "ca", name: "Canada" },
				{ id: "cl", name: "Chile" },
				{ id: "cn", name: "China" },
				{ id: "co", name: "Colombia" },
				{ id: "cu", name: "Cuba" },
				{ id: "cz", name: "Czech Republic" },
				{ id: "eg", name: "Egypt" },
				{ id: "fr", name: "France" },
				{ id: "de", name: "Germany" },
				{ id: "gr", name: "Greece" },
				{ id: "hu", name: "Hungaria" },
				{ id: "hk", name: "Hong-Kong" },
				{ id: "in", name: "India" },
				{ id: "id", name: "Indonesia" },
				{ id: "ie", name: "Ireland" },
				{ id: "il", name: "Israel" },
				{ id: "it", name: "Italia" },
				{ id: "jp", name: "Japan" },
				{ id: "kr", name: "Korea" },
				{ id: "mx", name: "Mexico" },
				{ id: "nl", name: "Netherlands" },
				{ id: "nz", name: "New-Zealand" },
				{ id: "no", name: "Norway" },
				{ id: "pl", name: "Poland" },
				{ id: "pt", name: "Portugal" },
				{ id: "qa", name: "Qatar" },
				{ id: "ru", name: "Russia" },
				{ id: "sa", name: "Saudi Arabia" },
				{ id: "sg", name: "Singapor" },
				{ id: "za", name: "South Africa" },
				{ id: "es", name: "Spain" },
				{ id: "se", name: "Sweden" },
				{ id: "ch", name: "Switzerland" },
				{ id: "tw", name: "Taiwan" },
				{ id: "th", name: "Thailand" },
				{ id: "tr", name: "Turkey" },
				{ id: "ua", name: "Ukraine" },
				{ id: "ae", name: "United Arab Emirates" },
				{ id: "uk", name: "UK" },
				{ id: "us", name: "USA" },
				{ id: "ve", name: "Venezuela" },
				{ id: "vn", name: "Vietnam" },
			],
		};
	},
	methods: {
		loadComponent() {
			this.getData("trendFilter");
		},
		treatResponse(response) {
			this.segments = response.data.segments;
			this.segmentsAll = response.data.segmentsAll;
			this.panels = response.data.panels;
			this.categories = response.data.categories;
			this.subcategories = response.data.allsubcats;
			this.mastertags = response.data.mastertags;
		},
		checkFilter() {
			//let country = this.selectedCountry == "" ? {} : this.selectedCountry;
			this.$emit("trendfilters", {
				panel: this.selectedPanel,
				segment: this.selectedSegment,
				date: this.selectedDate,
				country: this.selectedCountry,
				category: this.selectedCategory,
				subcategory: this.selectedSubCategory,
				mastertag: this.selectedMastertag,
			});
		},
		openTrendModel() {
			this.$refs.editcreatetrends.show();
		},
	},
	watch: {
		selectedPanel: function () {
			this.checkFilter();
		},
		selectedSegment: function () {
			this.checkFilter();
		},
		selectedDate: {
			deep: true,
			handler() {
				this.checkFilter();
			},
		},
		selectedCountry: function () {
			this.checkFilter();
		},
		selectedCategory: function () {
			this.checkFilter();
			this.$axios
				.get(this.$backendUrl + "getListMtCat", {
					params: {
						type: "categories",
						search: this.selectedCategory,
					},
					paramsSerializer: function (params) {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then((response) => {
					this.subcategories = response.data.data.map((x) => x.data.subcategories)[0];
				});
		},
		selectedSubCategory: function () {
			this.checkFilter();
		},
		selectedMastertag: function () {
			this.checkFilter();
		},
	},
};
</script>

<style></style>
